import HomeNavbar from './components/HomeNavbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import VendorSection from './components/VendorSection';
import OrganizerSection from './components/OrganizerSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import HomeFooter from './components/HomeFooter';

export default function Home() {
  return (
    <div className="min-h-screen">
      <HomeNavbar />
      <main>
        <HeroSection />
        <AboutSection />
        <VendorSection />
        <OrganizerSection />
        {/* <TestimonialsSection /> */}
        <CTASection />
      </main>
      <HomeFooter />
    </div>
  );
}
